import classNames from 'classnames'
import React from 'react'
import styles from './styles.module.scss'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { IconDefinition } from '@fortawesome/fontawesome-svg-core'

type Props = {
  className?: string
  selected?: boolean
  icon: IconDefinition
  location: string
  tip: string
}

export const Tab: React.FC<Props> = ({ className, icon, selected, location, tip }) => {
  return (
    <a href={location} className={classNames(styles.container, className, selected && styles.selected)} title={tip}>
      <FontAwesomeIcon icon={icon} className={styles.icon} />
    </a>
  )
}

export default Tab
